import React from 'react';
import { Document, Font, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
// @ts-ignore
import HelveticaNeueBold from '@honda-canada/design-system-react/lib/media/2EDEC5_0_0.woff';
// @ts-ignore
import HelveticaNeue from '@honda-canada/design-system-react/lib/media/2EDEC5_1_0.woff';
// @ts-ignore
import AcuraBespokeBold from '@honda-canada/design-system-react/lib/media/AcuraBespoke-Bold.woff';
// @ts-ignore
import AcuraBespoke from '@honda-canada/design-system-react/lib/media/acura_bespoke-regular.woff';
import { useTranslation } from 'react-i18next';
import getTitleMarkdown from './getTitleMarkdown';
import FirstPage from './FirstPage';
import Footer from './Footer';
import SelectedItemsPage from './SelectedItemsPage';
import Header from './Header';
import { getBreakdownGroupContentValue } from '../../PriceBreakdownModal/PriceBreakdownModalContent/usePriceBreakdownGroups';
import PriceBreakdown from './PriceBreakdown';
function splitAndModifyArray(arr) {
    const result = [];
    let i = 0;
    result.push(arr.slice(0, 2));
    i += 2;
    while (i < arr.length) {
        result.push(arr.slice(i, i + 5));
        i += 5;
    }
    result.forEach(subArray => {
        const seenIds = new Set();
        subArray.forEach(item => {
            if (seenIds.has(item.id)) {
                item.categoryTitle = '';
            }
            else {
                seenIds.add(item.id);
            }
        });
    });
    return result;
}
Font.register({
    family: 'Helvetica Neue',
    fonts: [
        {
            src: HelveticaNeue,
            fontWeight: 400,
        },
        {
            src: HelveticaNeueBold,
            fontWeight: 'bold',
        },
    ],
});
Font.register({
    family: 'Acura Bespoke',
    fonts: [
        {
            src: AcuraBespoke,
            fontWeight: 400,
        },
        {
            src: AcuraBespokeBold,
            fontWeight: 'bold',
        },
    ],
});
const SummaryCardPDF = ({ firstPageData, isVariant, selectedItems, groups, language }) => {
    var _a;
    const fontFamily = isVariant ? 'Acura Bespoke' : 'Helvetica Neue';
    const selectedItemsArrays = splitAndModifyArray(selectedItems);
    const { t } = useTranslation();
    const styles = StyleSheet.create({
        page: {
            padding: '32px 40px 120px',
            fontFamily,
            position: 'relative',
        },
    });
    const firstPageModelName = getTitleMarkdown(firstPageData.modelName, '18px');
    const PriceBreakdownModelName = getTitleMarkdown(firstPageData.modelName, '16px');
    return (React.createElement(Document, null,
        React.createElement(Page, { size: "A4", style: styles.page },
            React.createElement(FirstPage, { firstPageData: firstPageData, selectedItemsList: selectedItemsArrays[0], isVariant: isVariant, markdownModelName: firstPageModelName }),
            React.createElement(Footer, { isVariant: isVariant })), (_a = selectedItemsArrays === null || selectedItemsArrays === void 0 ? void 0 : selectedItemsArrays.slice(1)) === null || _a === void 0 ? void 0 :
        _a.map((item, index) => (React.createElement(Page, { size: "A4", style: styles.page, key: index },
            React.createElement(SelectedItemsPage, { selectedItemsList: item, isVariant: isVariant }),
            React.createElement(Footer, { isVariant: isVariant })))),
        React.createElement(Page, { size: "A4", style: styles.page },
            React.createElement(Header, null),
            React.createElement(Text, { style: { fontSize: '24px', fontWeight: 'bold', marginBottom: '8px', marginTop: '24px' } }, t('Pages.Bap.priceBreakdownButton')),
            React.createElement(View, { style: { display: 'flex', flexDirection: 'row', marginBottom: '16px' } }, PriceBreakdownModelName),
            React.createElement(PriceBreakdown, { getBreakdownGroupContentValue: getBreakdownGroupContentValue, groups: groups, language: language }),
            React.createElement(View, { break: true, wrap: false },
                React.createElement(Text, { style: { marginBottom: '24px', fontSize: '10px', color: '#707070' } }, t('Pages.Bap.disclaimerSummaryPdfText'))),
            React.createElement(Footer, { isVariant: isVariant }))));
};
export default SummaryCardPDF;
